<template>
  <div
    class="floating-icon flex-center"
    ref="dragging"
    :style="{ right: `${right}px`, bottom: `${bottom}px` }"
    @mousedown="startDrag"
    @mouseout="onMouseout = true"
    @mouseleave="onMouseout = false"
  >
    <div
      class="icon flex-center"
      @click="toggleVisibility"
      :class="[onMouseout ? 'text-show' : 'text-hide']"
    >
      <img src="@/static/draggable_icon.png" alt="" style="width: 24px; height: 24px" />
      <!-- <transition name="el-fade-in"> -->
      <span v-if="onMouseout" class="font-14 color-fff font-light margin-left-5">提交工单</span>
      <!-- </transition> -->
    </div>
    <workAdd v-if="workVisible" :visible="workVisible" @close="closeWork" />
  </div>
</template>

<script>
  import WorkAdd from '@/components/WorkAdd'
  export default {
    components: {
      WorkAdd
    },
    data() {
      return {
        isDragging: false,
        startX: 0,
        startY: 0,
        offsetX: 0,
        offsetY: 0,
        right: 0, // 默认位置，可以根据需要调整
        bottom: 60, // 默认位置，可以根据需要调整
        minRight: 20, // 最小右边距离
        maxRight: 200, // 最大右边距离
        maxBottom: 800, // 最大下边距离
        minBottom: 20, // 最小下边距离
        workVisible: false,
        flag: true,
        timer: null,
        onMouseout: false
      }
    },
    methods: {
      startDrag(event) {
        event.preventDefault()
        this.isDragging = true
        this.startX = event.clientX
        this.startY = event.clientY
        document.addEventListener('mousemove', this.drag)
        document.addEventListener('mouseup', this.stopDrag)
        this.$refs.dragging.setAttribute('flag', false)
        const firstTime = new Date().getTime()
        document.onmouseup = () => {
          document.onmousemove = null
          document.onmouseup = null
          // onmouseup 时的时间，并计算差值
          const lastTime = new Date().getTime()
          if (lastTime - firstTime < 200) {
            this.$refs.dragging.setAttribute('flag', true)
          }
        }
      },
      drag(event) {
        if (!this.isDragging) return
        this.offsetX = event.clientX - this.startX
        this.offsetY = event.clientY - this.startY
        const newRight = this.right - this.offsetX
        const newBottom = this.bottom - this.offsetY
        this.right = Math.max(this.minRight, Math.min(this.maxRight, newRight))
        this.bottom = Math.max(this.minBottom, Math.min(this.maxBottom, newBottom))
        this.startX = event.clientX
        this.startY = event.clientY
      },
      stopDrag() {
        this.isDragging = false
        document.removeEventListener('mousemove', this.drag)
        document.removeEventListener('mouseup', this.stopDrag)
      },
      toggleVisibility() {
        const isClick = this.$refs.dragging.getAttribute('flag')
        if (isClick === 'true') {
          this.workVisible = true
        } else return false
      },
      closeWork() {
        this.workVisible = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .floating-icon {
    position: fixed;
    cursor: move;
    z-index: 99999999;
  }

  .icon {
    background: #409eff;

    box-shadow: 0 3px 13px 0 hsla(0, 0%, 50%, 0.5);
  }
  .text-show {
    width: 120px;
    height: 48px;
    border-radius: 28px;
    transform: translateX(-10px);
    transition-duration: 0.2s;
  }
  .text-hide {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    transform: translateX(0px);
    transition-duration: 0.2s;
  }
</style>
